<section class="financiamiento-section">
    <div class="financiamiento-overlay"></div>
    <div class="hero-container">
        <h1 class="hero-title animate-hero-title">
            Tesoreria y Gestión del Capital de Trabajo
        </h1>
    </div>
</section>
<section class="services-detail-section" #servicesSection>
    <div class="container">
        <div class="services-detail-content">

            <!-- Columna izquierda: Texto + Imagen -->
            <div class="services-left">
                <h2 class="services-intro animate-on-scroll" [class.visible]="isVisible" style="--delay: 0s">
                    Optimizamos el manejo diario de los recursos financieros. </h2>
                <div class="services-image animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.2s">
                    <img src="/assets/Tarjetas servicios/2 Tesoreria.jpg" alt="Financiamiento y Mercado de Capitales">
                </div>
            </div>

            <!-- Columna derecha: Lista de servicios -->
            <div class="services-right">
                <ul class="services-list">
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.3s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Gestión de flujo de caja.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.4s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Estrategia de cobranza.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.5s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Estrategia de pagos.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.6s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Administración de excedentes financieros.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.7s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Armado de carpetas para avales SGR.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.8s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Segumiento mensual de liquidez.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.9s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Optimización del capital de trabajo.</span>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</section>
<app-cta-section></app-cta-section>